import { compact } from "lodash";

export enum PerformanceCompareConfigKey {
    OneSlot = "one-slot",
    FourSlots = "four-slots",
    FourSlotsNoOffer = "four-slots-no-offer",
    OneMonth = "one-month",
    EightSlots = "eight-slots",
    EightSlotsNoOffer = "eight-slots-no-offer",
    LastYear = "n-1",
}

export enum PerformanceCompareDistributionMetricEnum {
    PERIOD_WITHOUT_MARKETING_ACTION = "period-without-marketing-action",
    PREVIOUS_PERIOD = "previous-period",
    PREVIOUS_YEAR = "previous-year",
}

export const COMPARE_PERIOD_CONFIG = {
    [PerformanceCompareDistributionMetricEnum.PERIOD_WITHOUT_MARKETING_ACTION]: [
        PerformanceCompareConfigKey.FourSlotsNoOffer,
        PerformanceCompareConfigKey.EightSlotsNoOffer,
    ],
    [PerformanceCompareDistributionMetricEnum.PREVIOUS_PERIOD]: compact([
        PerformanceCompareConfigKey.OneSlot,
        PerformanceCompareConfigKey.OneMonth,
        PerformanceCompareConfigKey.FourSlots,
        PerformanceCompareConfigKey.EightSlots,
    ]),
    [PerformanceCompareDistributionMetricEnum.PREVIOUS_YEAR]: [
        PerformanceCompareConfigKey.LastYear,
    ],
};
